import type { BannerType } from "~/features/banner/types";
import { trackFirebaseEvent } from "./analytics";
import {
  FIREBASE_EVENT_NAME,
  type FirebaseBannerPlacement,
  type FirebaseBannerType,
  type FirebaseExtraBannerType,
} from "./types";

/** camelCase → snake_case（FirebaseBannerType の CamelToSnake と同じ変換。snake_case はそのまま通る） */
const toSnakeCase = (value: string): string =>
  value.replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);

/**
 * バナーのタップを banner_tap として送る。
 * banner_type は BannerType（camelCase）も受け取り、全て snake_case に揃えて送る。
 */
export const trackBannerTap = (
  placement: FirebaseBannerPlacement,
  bannerType: BannerType | FirebaseExtraBannerType,
): void => {
  trackFirebaseEvent(FIREBASE_EVENT_NAME.BANNER_TAP, {
    placement,
    // 型側の CamelToSnake と同じ変換なので、結果は FirebaseBannerType に収まる
    banner_type: toSnakeCase(bannerType) as FirebaseBannerType,
  });
};
